/**
 * Faceta «Conversa por ID» — o único resto útil de `conversations?search=`.
 *
 * D6 da spec: aquela busca casa `id` ∪ `person.displayName` ∪
 * `identity.channelIdentifier`. Nome e telefone são exatamente o que a faceta
 * Pessoas já responde, e melhor (devolve a PESSOA, com o total real de
 * conversas, em vez de cards de conversa soltos — decisão da rodada 2 da Inbox).
 * Sobra o id colado, que é resposta única e vai SEMPRE no topo: `orderSections`
 * fixa esta seção lá.
 *
 * Formato medido no banco de dev em 14/Ago: `conv_` + ULID de 26 caracteres
 * (ex.: `conv_01KZ25N7CNJJ56Q99BCPSACX6A`). O alfabeto de ULID exclui I, L, O e
 * U de propósito, mas o regex aceita o alfanumérico inteiro: rejeitar um id
 * válido é pior que aceitar um termo que o backend vai simplesmente não achar.
 */
import { useConversations } from '../../hooks/use-conversations';

import type { SpotlightItem } from './types';

const CONVERSATION_ID = /^conv_[0-9A-Za-z]{26}$/;

export function looksLikeConversationId(term: string): boolean {
  return CONVERSATION_ID.test(term.trim());
}

export function useConversationIdHit(term: string): SpotlightItem[] {
  const id = term.trim();
  const enabled = looksLikeConversationId(id);
  // O filtro vazio quando desabilitado mantém a queryKey estável e evita
  // guardar no cache uma entrada por tecla digitada.
  const { data } = useConversations(enabled ? { search: id } : {}, enabled);
  if (!enabled) return [];
  return (data?.data ?? []).map((c) => ({
    key: `conversation:${c.id}`,
    section: 'conversation-id' as const,
    label: c.person?.displayName ?? 'Conversa sem pessoa vinculada',
    meta: 'abrir por ID',
    to: `/atendimento/conversation/${c.id}`,
  }));
}
